// extracted by mini-css-extract-plugin
module.exports = {"adminContent":"_3qqTbWh_","dashboardTitleContainer":"_1TCR1Hyn","adminHeader":"qaSBJeOp","adminHeaderLeft":"_3kF6WQ08","adminHeaderBold":"_2QG5vADK","adminHeaderText":"_1L0jhCIg","nameHeader":"_1CKMJzc_","updatedAtContent":"_1_s7onjQ","updatedAtHeader":"_1tjcs6-y","lastActivityContent":"zSUUN010","lastActivityHeader":"_1ipVbnlL"};
    if(module.hot) {
      // 1746735834233
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  